import { Box, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { ChargeFormEntry } from '../../../../types';
import { formatMoney } from 'utils/helpers';

const useStyles = makeStyles((theme) => ({
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    backgroundColor: theme.palette.background.default,
    padding: '0.5rem',
    borderRadius: '5px',
    cursor: 'pointer',
    justifyContent: 'flex-end',
  },
  text: {
    fontSize: '0.8rem',
    color: theme.palette.text.primary,
  },
}));

type Props = {
  charge: ChargeFormEntry;
  onOpenSplitModal: () => void;
};

export const TaxField: FC<Props> = ({ charge, onOpenSplitModal }) => {
  const classes = useStyles();

  const isDisabled = charge.accounting_id === null || charge.disabled;

  return (
    <Tooltip
      title={
        charge.accounting_id
          ? 'Click this field to open a selection window where you can choose the parties involved'
          : 'Charge must be saved before selecting parties'
      }
    >
      <Box
        className={classes.inputContainer}
        style={{
          height: '2rem',
          minWidth: '3rem',
          cursor: !isDisabled ? 'pointer' : 'not-allowed',
        }}
        onClick={() => !isDisabled && onOpenSplitModal()}
      >
        <Typography className={classes.text}>{formatMoney(charge.tax)}</Typography>
      </Box>
    </Tooltip>
  );
};
